// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"54":"923c80bf","104":"1eb77791","119":"1eb77791","150":"d0979c8f","234":"1eb77791","341":"1eb77791","791":"485c448a","981":"5f7b6402"}[chunkId] + ".css";
};